import React from 'react';
import styles from './LoginError.module.scss';
import { ReactComponent as LoginError } from '@/assets/icons/LoginError.svg';

interface LoginErrorCardProps {
  onClose: () => void;
  attemptedEmail?: string | null;
}

export const LoginErrorCard: React.FC<LoginErrorCardProps> = ({ onClose, attemptedEmail }) => {
  const normalizedEmail =
    typeof attemptedEmail === 'string' && attemptedEmail.trim().length > 0
      ? attemptedEmail.trim()
      : null;

  return (
    <div className={styles.cardContainer}>
      <div className={styles.logoContainer}>
        <LoginError />
      </div>
      <h2 className={styles.text}>Login Error!</h2>
      <p className={styles.subText}>
        Something went wrong.
        <br />
        Please try again later.
      </p>
      {normalizedEmail ? (
        <p className={styles.accountText}>
          Account: <span className={styles.accountEmail}>{normalizedEmail}</span>
        </p>
      ) : null}
      <button className={styles.button} onClick={onClose}>
        Close
      </button>
    </div>
  );
};
